// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';

export enum CovidMetaDataItemNames {
    CovidConfiguration = 'CovidConfiguration',
    CovidTestResultType = 'CovidTestResultType',
    CovidTestStatus = 'CovidTestStatus',
    CovidTestType = 'CovidTestType',
    CovidVaccinationStatus = 'CovidVaccinationStatus',
    CovidVaccinationSubmissionStatus = 'CovidVaccinationSubmissionStatus',
    CovidVaccineType = 'CovidVaccineType',
    CovidWorkStatus = 'CovidWorkStatus',
    EmployeeReminderNotification = 'EmployeeReminderNotification',
    EmployeeServiceDates = 'EmployeeServiceDates',
    EmployeeSummary = 'EmployeeSummary',
    EmployeeSummaryChangeType = 'EmployeeSummaryChangeType',
    EmployeeSummaryHistory = 'EmployeeSummaryHistory',
    EmployeeTest = 'EmployeeTest',
    EmployeeVaccinationSubmission = 'EmployeeVaccinationSubmission',
    EthosUser = 'Ethos_User',
    EthosUserDiff = 'Ethos_UserDiff',
    EthosUserSkill = 'Ethos_UserSkill',
    FieldEmployeesPayRate = 'FieldEmployeesPayRate',
    RoEthosUser = 'roEthos_User',
}

export enum CovidMetaDataLookups {
    CovidConfigurationAllItems = 1674,
    CovidTestResultTypeAllItems = 1663,
    CovidTestStatusAllItems = 1664,
    CovidTestTypeAllItems = 1670,
    CovidVaccinationStatusAllItems = 1665,
    CovidVaccinationSubmissionStatusAllItems = 1673,
    CovidVaccineTypeAllItems = 1666,
    CovidWorkStatusAllItems = 1667,
    EmployeeReminderNotificationAllItems = 1686,
    EmployeeServiceDatesAllItems = 1625,
    EmployeeSummaryAllItems = 1668,
    EmployeeSummaryChangeTypeAllItems = 1675,
    EmployeeSummaryHistoryAllItems = 1676,
    EmployeeTestAllItems = 1669,
    EmployeeVaccinationSubmissionAllItems = 1672,
    EthosUserByUsersDepartment = 1582,
    ETHOSUSERWachterEmployeesActiveEmployees = 1464,
    EthosUserAllItems = 1416,
    EthosUserDiffAllItems = 1623,
    EthosUserSkillAllItems = 1413,
    FieldEmployeesPayRateAllItems = 1555,
    RoEthosUserAllItems = 1422,
}

@Injectable({
    providedIn: 'root'
})
export class CovidMetaDataService {

    CovidConfiguration : CovidConfiguration = new CovidConfiguration();
    CovidTestResultType : CovidTestResultType = new CovidTestResultType();
    CovidTestStatus : CovidTestStatus = new CovidTestStatus();
    CovidTestType : CovidTestType = new CovidTestType();
    CovidVaccinationStatus : CovidVaccinationStatus = new CovidVaccinationStatus();
    CovidVaccinationSubmissionStatus : CovidVaccinationSubmissionStatus = new CovidVaccinationSubmissionStatus();
    CovidVaccineType : CovidVaccineType = new CovidVaccineType();
    CovidWorkStatus : CovidWorkStatus = new CovidWorkStatus();
    EmployeeReminderNotification : EmployeeReminderNotification = new EmployeeReminderNotification();
    EmployeeServiceDates : EmployeeServiceDates = new EmployeeServiceDates();
    EmployeeSummary : EmployeeSummary = new EmployeeSummary();
    EmployeeSummaryChangeType : EmployeeSummaryChangeType = new EmployeeSummaryChangeType();
    EmployeeSummaryHistory : EmployeeSummaryHistory = new EmployeeSummaryHistory();
    EmployeeTest : EmployeeTest = new EmployeeTest();
    EmployeeVaccinationSubmission : EmployeeVaccinationSubmission = new EmployeeVaccinationSubmission();
    EthosUser : EthosUser = new EthosUser();
    EthosUserDiff : EthosUserDiff = new EthosUserDiff();
    EthosUserSkill : EthosUserSkill = new EthosUserSkill();
    FieldEmployeesPayRate : FieldEmployeesPayRate = new FieldEmployeesPayRate();
    RoEthosUser : RoEthosUser = new RoEthosUser();
}

// Generated Classes for MetaData service
class CovidConfiguration implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidConfiguration.';

    constructor() {
        this.ItemDetail.ItemId=2616;
        this.ItemDetail.ItemName='CovidConfiguration';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidConfigurationId : string = this.i + 'CovidConfigurationId';
    TestFrequencyDays : string = this.i + 'TestFrequencyDays';
    QuarantineDays : string = this.i + 'QuarantineDays';
    TestStartAfterPositiveDays : string = this.i + 'TestStartAfterPositiveDays';
    EffectiveStartDate : string = this.i + 'EffectiveStartDate';
    RequireWeeklyTesting : string = this.i + 'RequireWeeklyTesting';
    EffectiveEndDate : string = this.i + 'EffectiveEndDate';
    ShowHomePageContent : string = this.i + 'ShowHomePageContent';
    HomePageMessage : string = this.i + 'HomePageMessage';
    ReminderEmail1DaysBefore : string = this.i + 'ReminderEmail1DaysBefore';
    ReminderEmail2DaysBefore : string = this.i + 'ReminderEmail2DaysBefore';
    ReminderEmail3DaysBefore : string = this.i + 'ReminderEmail3DaysBefore';

    Relations = {
    };
}

class CovidTestResultType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidTestResultType.';

    constructor() {
        this.ItemDetail.ItemId=2605;
        this.ItemDetail.ItemName='CovidTestResultType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidTestResultTypeId : string = this.i + 'CovidTestResultTypeId';
    CovidTestResultType : string = this.i + 'CovidTestResultType';

    Relations = {
            /** Relation: Employee Test */
            EmployeeTest : {
                RelationName: 'CovidTestResultType|EmployeeTest|CovidTestResultTypeId',
                FieldPrefix: 'EmployeeTest',
                PropertyName: 'EmployeeTest'
            },
    };
}

class CovidTestStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidTestStatus.';

    constructor() {
        this.ItemDetail.ItemId=2606;
        this.ItemDetail.ItemName='CovidTestStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidTestStatusId : string = this.i + 'CovidTestStatusId';
    CovidTestStatus : string = this.i + 'CovidTestStatus';
    CovidTestStatusActionTest : string = this.i + 'CovidTestStatusActionTest';
    ButtonClasses : string = this.i + 'ButtonClasses';

    Relations = {
            /** Relation: Employee Test */
            EmployeeTest : {
                RelationName: 'CovidTestStatus|EmployeeTest|CovidTestStatusId',
                FieldPrefix: 'EmployeeTest',
                PropertyName: 'EmployeeTest'
            },
    };
}

class CovidTestType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidTestType.';

    constructor() {
        this.ItemDetail.ItemId=2612;
        this.ItemDetail.ItemName='CovidTestType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidTestTypeId : string = this.i + 'CovidTestTypeId';
    CovidTestType : string = this.i + 'CovidTestType';

    Relations = {
            /** Relation: Employee Test */
            EmployeeTest : {
                RelationName: 'CovidTestType|EmployeeTest|CovidTestTypeId',
                FieldPrefix: 'EmployeeTest',
                PropertyName: 'EmployeeTest'
            },
    };
}

class CovidVaccinationStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidVaccinationStatus.';

    constructor() {
        this.ItemDetail.ItemId=2607;
        this.ItemDetail.ItemName='CovidVaccinationStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidVaccinationStatusId : string = this.i + 'CovidVaccinationStatusId';
    CovidVaccinationStatus : string = this.i + 'CovidVaccinationStatus';

    Relations = {
            /** Relation: Employee Summary */
            EmployeeSummary : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummary|CovidVaccinationStatusId',
                FieldPrefix: 'EmployeeSummary',
                PropertyName: 'EmployeeSummary'
            },
            /** Relation: Employee Vaccination Submission */
            EmployeeVaccinationSubmission : {
                RelationName: 'CovidVaccinationStatus|EmployeeVaccinationSubmission|CovidVaccinationStatusId',
                FieldPrefix: 'EmployeeVaccinationSubmission',
                PropertyName: 'EmployeeVaccinationSubmission'
            },
            /** Relation: Employee Summary History - Covid Vaccination Status Id */
            EmployeeSummaryHistoryByPreviousCovidVaccinationStatusId : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummaryHistory|PreviousCovidVaccinationStatusId',
                FieldPrefix: 'PreviousEmployeeSummaryHistory',
                PropertyName: 'PreviousEmployeeSummaryHistory'
            },
            /** Relation: Employee Summary History */
            EmployeeSummaryHistory : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummaryHistory|CovidVaccinationStatusId',
                FieldPrefix: 'EmployeeSummaryHistory',
                PropertyName: 'EmployeeSummaryHistory'
            },
    };
}

class CovidVaccinationSubmissionStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidVaccinationSubmissionStatus.';

    constructor() {
        this.ItemDetail.ItemId=2615;
        this.ItemDetail.ItemName='CovidVaccinationSubmissionStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidVaccinationSubmissionStatusId : string = this.i + 'CovidVaccinationSubmissionStatusId';
    StatusDisplay : string = this.i + 'StatusDisplay';
    StatusActionText : string = this.i + 'StatusActionText';
    ButtonClasses : string = this.i + 'ButtonClasses';

    Relations = {
            /** Relation: Employee Vaccination Submission */
            EmployeeVaccinationSubmission : {
                RelationName: 'CovidVaccinationSubmissionStatus|EmployeeVaccinationSubmission|CovidVaccinationSubmissionStatusId',
                FieldPrefix: 'EmployeeVaccinationSubmission',
                PropertyName: 'EmployeeVaccinationSubmission'
            },
    };
}

class CovidVaccineType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidVaccineType.';

    constructor() {
        this.ItemDetail.ItemId=2608;
        this.ItemDetail.ItemName='CovidVaccineType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidVaccineTypeId : string = this.i + 'CovidVaccineTypeId';
    CovidVaccineType : string = this.i + 'CovidVaccineType';
    RequiredShots : string = this.i + 'RequiredShots';

    Relations = {
            /** Relation: Employee Summary - Covid Vaccine Type Id */
            EmployeeSummaryByBoosterVaccine1TypeId : {
                RelationName: 'CovidVaccineType|EmployeeSummary|BoosterVaccine1TypeId',
                FieldPrefix: 'BoosterVaccine1TypeIdEmployeeSummary',
                PropertyName: 'BoosterVaccine1TypeIdEmployeeSummary'
            },
            /** Relation: Employee Summary - Covid Vaccine Type Id */
            EmployeeSummaryByVaccineTypeId : {
                RelationName: 'CovidVaccineType|EmployeeSummary|VaccineTypeId',
                FieldPrefix: 'VaccineTypeIdEmployeeSummary',
                PropertyName: 'VaccineTypeIdEmployeeSummary'
            },
            /** Relation: Employee Vaccination Submission - Covid Vaccine Type Id */
            EmployeeVaccinationSubmissionByVaccinationTypeId : {
                RelationName: 'CovidVaccineType|EmployeeVaccinationSubmission|VaccinationTypeId',
                FieldPrefix: 'VaccinationTypeIdEmployeeVaccinationSubmission',
                PropertyName: 'VaccinationTypeIdEmployeeVaccinationSubmission'
            },
            /** Relation: Employee Vaccination Submission - Covid Vaccine Type Id */
            EmployeeVaccinationSubmissionByBoosterVaccine1TypeId : {
                RelationName: 'CovidVaccineType|EmployeeVaccinationSubmission|BoosterVaccine1TypeId',
                FieldPrefix: 'BoosterVaccine1TypeIdEmployeeVaccinationSubmission',
                PropertyName: 'BoosterVaccine1TypeIdEmployeeVaccinationSubmission'
            },
    };
}

class CovidWorkStatus implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CovidWorkStatus.';

    constructor() {
        this.ItemDetail.ItemId=2609;
        this.ItemDetail.ItemName='CovidWorkStatus';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CovidWorkStatusId : string = this.i + 'CovidWorkStatusId';
    CovidWorkStatus : string = this.i + 'CovidWorkStatus';

    Relations = {
            /** Relation: Employee Summary */
            EmployeeSummary : {
                RelationName: 'CovidWorkStatus|EmployeeSummary|CovidWorkStatusId',
                FieldPrefix: 'EmployeeSummary',
                PropertyName: 'EmployeeSummary'
            },
            /** Relation: Employee Summary History */
            EmployeeSummaryHistory : {
                RelationName: 'CovidWorkStatus|EmployeeSummaryHistory|CovidWorkStatusId',
                FieldPrefix: 'EmployeeSummaryHistory',
                PropertyName: 'EmployeeSummaryHistory'
            },
            /** Relation: Employee Summary History - Covid Work Status Id */
            EmployeeSummaryHistoryByPreviousCovidWorkStatusId : {
                RelationName: 'CovidWorkStatus|EmployeeSummaryHistory|PreviousCovidWorkStatusId',
                FieldPrefix: 'PreviousEmployeeSummaryHistory',
                PropertyName: 'PreviousEmployeeSummaryHistory'
            },
    };
}

class EmployeeReminderNotification implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeReminderNotification.';

    constructor() {
        this.ItemDetail.ItemId=2619;
        this.ItemDetail.ItemName='EmployeeReminderNotification';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeSummaryId : string = this.i + 'EmployeeSummaryId';
    DaysUntilNextTest : string = this.i + 'DaysUntilNextTest';
    NextTestDate : string = this.i + 'NextTestDate';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    EmployeeReminderNotificationId : string = this.i + 'EmployeeReminderNotificationId';

    Relations = {
            /** Relation: Employee Summary */
            EmployeeSummary : {
                RelationName: 'EmployeeSummary|EmployeeReminderNotification|EmployeeSummaryId',
                FieldPrefix: 'EmployeeSummary',
                PropertyName: 'EmployeeSummary'
            },
    };
}

class EmployeeServiceDates implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeServiceDates.';

    constructor() {
        this.ItemDetail.ItemId=2574;
        this.ItemDetail.ItemName='EmployeeServiceDates';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    PersonnelNumber : string = this.i + 'PersonnelNumber';
    HireDate : string = this.i + 'HireDate';
    EmploymentStartDate : string = this.i + 'EmploymentStartDate';
    AdjustedServiceDate : string = this.i + 'AdjustedServiceDate';

    Relations = {
    };
}

class EmployeeSummary implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeSummary.';

    constructor() {
        this.ItemDetail.ItemId=2610;
        this.ItemDetail.ItemName='EmployeeSummary';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeSummaryId : string = this.i + 'EmployeeSummaryId';
    EmployeeUserId : string = this.i + 'EmployeeUserId';
    CovidVaccinationStatusId : string = this.i + 'CovidVaccinationStatusId';
    CovidWorkStatusId : string = this.i + 'CovidWorkStatusId';
    RequiresWeeklyTesting : string = this.i + 'RequiresWeeklyTesting';
    NextTestDate : string = this.i + 'NextTestDate';
    QuarantineStartDate : string = this.i + 'QuarantineStartDate';
    QuarantineEndDate : string = this.i + 'QuarantineEndDate';
    Vaccine1Date : string = this.i + 'Vaccine1Date';
    Vaccine2Date : string = this.i + 'Vaccine2Date';
    BoosterVaccine1TypeId : string = this.i + 'BoosterVaccine1TypeId';
    BoosterVaccine1Date : string = this.i + 'BoosterVaccine1Date';
    VaccinationCardFileId : string = this.i + 'VaccinationCardFileId';
    CreatedBy : string = this.i + 'CreatedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    LastEmployeeTestId : string = this.i + 'LastEmployeeTestId';
    VaccineTypeId : string = this.i + 'VaccineTypeId';
    LastPositiveTestId : string = this.i + 'LastPositiveTestId';
    MedicalExemptionFileId : string = this.i + 'MedicalExemptionFileId';

    Relations = {
            /** Relation: Covid Vaccine Type - Booster Vaccination Type */
            CovidVaccineTypeByBoosterVaccine1TypeId : {
                RelationName: 'CovidVaccineType|EmployeeSummary|BoosterVaccine1TypeId',
                FieldPrefix: 'BoosterVaccine1TypeIdCovidVaccineType',
                PropertyName: 'BoosterVaccine1TypeIdCovidVaccineType'
            },
            /** Relation: Employee Reminder Notification */
            EmployeeReminderNotification : {
                RelationName: 'EmployeeSummary|EmployeeReminderNotification|EmployeeSummaryId',
                FieldPrefix: 'EmployeeReminderNotification',
                PropertyName: 'EmployeeReminderNotification'
            },
            /** Relation: Covid Work Status */
            CovidWorkStatus : {
                RelationName: 'CovidWorkStatus|EmployeeSummary|CovidWorkStatusId',
                FieldPrefix: 'CovidWorkStatus',
                PropertyName: 'CovidWorkStatus'
            },
            /** Relation: Covid Vaccine Type - Vaccine Type */
            CovidVaccineTypeByVaccineTypeId : {
                RelationName: 'CovidVaccineType|EmployeeSummary|VaccineTypeId',
                FieldPrefix: 'VaccineTypeIdCovidVaccineType',
                PropertyName: 'VaccineTypeIdCovidVaccineType'
            },
            /** Relation: User - Employee */
            EthosUserByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeSummary|EmployeeUserId',
                FieldPrefix: 'EmployeeEthosUser',
                PropertyName: 'EmployeeEthosUser'
            },
            /** Relation: Employee Summary History */
            EmployeeSummaryHistory : {
                RelationName: 'EmployeeSummary|EmployeeSummaryHistory|EmployeeSummaryId',
                FieldPrefix: 'EmployeeSummaryHistory',
                PropertyName: 'EmployeeSummaryHistory'
            },
            /** Relation: Covid Vaccination Status */
            CovidVaccinationStatus : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummary|CovidVaccinationStatusId',
                FieldPrefix: 'CovidVaccinationStatus',
                PropertyName: 'CovidVaccinationStatus'
            },
            /** Relation: Employee Test - Last Positive Test */
            EmployeeTestByLastPositiveTestId : {
                RelationName: 'EmployeeTest|EmployeeSummary|LastPositiveTestId',
                FieldPrefix: 'LastPositiveTestIdEmployeeTest',
                PropertyName: 'LastPositiveTestIdEmployeeTest'
            },
            /** Relation: Employee Test - Last Employee Test */
            EmployeeTestByLastEmployeeTestId : {
                RelationName: 'EmployeeTest|EmployeeSummary|LastEmployeeTestId',
                FieldPrefix: 'LastEmployeeTest',
                PropertyName: 'LastEmployeeTest'
            },
    };
}

class EmployeeSummaryChangeType implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeSummaryChangeType.';

    constructor() {
        this.ItemDetail.ItemId=2617;
        this.ItemDetail.ItemName='EmployeeSummaryChangeType';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmplyoeeSummaryChangeTypeId : string = this.i + 'EmplyoeeSummaryChangeTypeId';
    ChangeTypeDisplay : string = this.i + 'ChangeTypeDisplay';
    EmailEmployee : string = this.i + 'EmailEmployee';
    EmailSupervisor : string = this.i + 'EmailSupervisor';

    Relations = {
            /** Relation: Employee Summary History - Emplyoee Summary Change Type Id */
            EmployeeSummaryHistoryByEmployeeSummaryChangeTypeId : {
                RelationName: 'EmployeeSummaryChangeType|EmployeeSummaryHistory|EmployeeSummaryChangeTypeId',
                FieldPrefix: 'EmployeeSummaryChangeTypeIdEmployeeSummaryHistory',
                PropertyName: 'EmployeeSummaryChangeTypeIdEmployeeSummaryHistory'
            },
    };
}

class EmployeeSummaryHistory implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeSummaryHistory.';

    constructor() {
        this.ItemDetail.ItemId=2618;
        this.ItemDetail.ItemName='EmployeeSummaryHistory';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeSummaryHistoryId : string = this.i + 'EmployeeSummaryHistoryId';
    EmployeeSummaryId : string = this.i + 'EmployeeSummaryId';
    EmployeeSummaryChangeTypeId : string = this.i + 'EmployeeSummaryChangeTypeId';
    CovidVaccinationStatusId : string = this.i + 'CovidVaccinationStatusId';
    PreviousCovidVaccinationStatusId : string = this.i + 'PreviousCovidVaccinationStatusId';
    CovidWorkStatusId : string = this.i + 'CovidWorkStatusId';
    PreviousCovidWorkStatusId : string = this.i + 'PreviousCovidWorkStatusId';
    QuarantineStartDate : string = this.i + 'QuarantineStartDate';
    QuarantineEndDate : string = this.i + 'QuarantineEndDate';
    DetailNotificationsComplete : string = this.i + 'DetailNotificationsComplete';
    SummaryNotificationsComplete : string = this.i + 'SummaryNotificationsComplete';
    RequireWeeklyTesting : string = this.i + 'RequireWeeklyTesting';
    PreviousRequireWeeklyTesting : string = this.i + 'PreviousRequireWeeklyTesting';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';

    Relations = {
            /** Relation: Covid Vaccination Status - Previous Vaccination Status */
            CovidVaccinationStatusByPreviousCovidVaccinationStatusId : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummaryHistory|PreviousCovidVaccinationStatusId',
                FieldPrefix: 'PreviousCovidVaccinationStatus',
                PropertyName: 'PreviousCovidVaccinationStatus'
            },
            /** Relation: Covid Work Status - Previous Work Status */
            CovidWorkStatusByPreviousCovidWorkStatusId : {
                RelationName: 'CovidWorkStatus|EmployeeSummaryHistory|PreviousCovidWorkStatusId',
                FieldPrefix: 'PreviousCovidWorkStatus',
                PropertyName: 'PreviousCovidWorkStatus'
            },
            /** Relation: Employee Summary Change Type - Employee Summary Change Type */
            EmployeeSummaryChangeTypeByEmployeeSummaryChangeTypeId : {
                RelationName: 'EmployeeSummaryChangeType|EmployeeSummaryHistory|EmployeeSummaryChangeTypeId',
                FieldPrefix: 'EmployeeSummaryChangeTypeIdEmployeeSummaryChangeType',
                PropertyName: 'EmployeeSummaryChangeTypeIdEmployeeSummaryChangeType'
            },
            /** Relation: Employee Summary */
            EmployeeSummary : {
                RelationName: 'EmployeeSummary|EmployeeSummaryHistory|EmployeeSummaryId',
                FieldPrefix: 'EmployeeSummary',
                PropertyName: 'EmployeeSummary'
            },
            /** Relation: Covid Vaccination Status */
            CovidVaccinationStatus : {
                RelationName: 'CovidVaccinationStatus|EmployeeSummaryHistory|CovidVaccinationStatusId',
                FieldPrefix: 'CovidVaccinationStatus',
                PropertyName: 'CovidVaccinationStatus'
            },
            /** Relation: Covid Work Status */
            CovidWorkStatus : {
                RelationName: 'CovidWorkStatus|EmployeeSummaryHistory|CovidWorkStatusId',
                FieldPrefix: 'CovidWorkStatus',
                PropertyName: 'CovidWorkStatus'
            },
    };
}

class EmployeeTest implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeTest.';

    constructor() {
        this.ItemDetail.ItemId=2611;
        this.ItemDetail.ItemName='EmployeeTest';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeTestId : string = this.i + 'EmployeeTestId';
    EmployeeUserId : string = this.i + 'EmployeeUserId';
    TestLocation : string = this.i + 'TestLocation';
    CovidTestTypeId : string = this.i + 'CovidTestTypeId';
    CovidTestResultTypeId : string = this.i + 'CovidTestResultTypeId';
    CovidTestStatusId : string = this.i + 'CovidTestStatusId';
    VerifiedByUserId : string = this.i + 'VerifiedByUserId';
    VerifiedDateTime : string = this.i + 'VerifiedDateTime';
    RejectedByUserId : string = this.i + 'RejectedByUserId';
    RejectedDateTime : string = this.i + 'RejectedDateTime';
    RejectedNotes : string = this.i + 'RejectedNotes';
    TestFileId : string = this.i + 'TestFileId';
    TestDateTime : string = this.i + 'TestDateTime';
    CreatedBy : string = this.i + 'CreatedBy';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    IsProcessed : string = this.i + 'IsProcessed';
    ProcessedDateTime : string = this.i + 'ProcessedDateTime';

    Relations = {
            /** Relation: Covid Test Type */
            CovidTestType : {
                RelationName: 'CovidTestType|EmployeeTest|CovidTestTypeId',
                FieldPrefix: 'CovidTestType',
                PropertyName: 'CovidTestType'
            },
            /** Relation: Employee Summary - Employee Test Id */
            EmployeeSummaryByLastPositiveTestId : {
                RelationName: 'EmployeeTest|EmployeeSummary|LastPositiveTestId',
                FieldPrefix: 'LastPositiveTestIdEmployeeSummary',
                PropertyName: 'LastPositiveTestIdEmployeeSummary'
            },
            /** Relation: Covid Test Status */
            CovidTestStatus : {
                RelationName: 'CovidTestStatus|EmployeeTest|CovidTestStatusId',
                FieldPrefix: 'CovidTestStatus',
                PropertyName: 'CovidTestStatus'
            },
            /** Relation: Employee Summary - Employee Test Id */
            EmployeeSummaryByLastEmployeeTestId : {
                RelationName: 'EmployeeTest|EmployeeSummary|LastEmployeeTestId',
                FieldPrefix: 'LastEmployeeSummary',
                PropertyName: 'LastEmployeeSummary'
            },
            /** Relation: User - Employee */
            EthosUserByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeTest|EmployeeUserId',
                FieldPrefix: 'EmployeeEthosUser',
                PropertyName: 'EmployeeEthosUser'
            },
            /** Relation: Covid Test Result Type */
            CovidTestResultType : {
                RelationName: 'CovidTestResultType|EmployeeTest|CovidTestResultTypeId',
                FieldPrefix: 'CovidTestResultType',
                PropertyName: 'CovidTestResultType'
            },
    };
}

class EmployeeVaccinationSubmission implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EmployeeVaccinationSubmission.';

    constructor() {
        this.ItemDetail.ItemId=2614;
        this.ItemDetail.ItemName='EmployeeVaccinationSubmission';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EmployeeVaccinationSubmissionId : string = this.i + 'EmployeeVaccinationSubmissionId';
    EmployeeUserId : string = this.i + 'EmployeeUserId';
    SubmittedDateTime : string = this.i + 'SubmittedDateTime';
    CovidVaccinationStatusId : string = this.i + 'CovidVaccinationStatusId';
    VaccinationTypeId : string = this.i + 'VaccinationTypeId';
    Vaccine1Date : string = this.i + 'Vaccine1Date';
    Vaccine2Date : string = this.i + 'Vaccine2Date';
    BoosterVaccine1TypeId : string = this.i + 'BoosterVaccine1TypeId';
    BoosterVaccineDate : string = this.i + 'BoosterVaccineDate';
    VaccinationCardFileId : string = this.i + 'VaccinationCardFileId';
    CovidVaccinationSubmissionStatusId : string = this.i + 'CovidVaccinationSubmissionStatusId';
    VerifiedDateTime : string = this.i + 'VerifiedDateTime';
    RejectedByUserId : string = this.i + 'RejectedByUserId';
    RejectedDateTime : string = this.i + 'RejectedDateTime';
    RejectedNotes : string = this.i + 'RejectedNotes';
    VerifiedByUserId : string = this.i + 'VerifiedByUserId';

    Relations = {
            /** Relation: User - Verified By User */
            EthosUserByVerifiedByUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|VerifiedByUserId',
                FieldPrefix: 'VerifiedByEthosUser',
                PropertyName: 'VerifiedByEthosUser'
            },
            /** Relation: Covid Vaccine Type - Vaccination Type */
            CovidVaccineTypeByVaccinationTypeId : {
                RelationName: 'CovidVaccineType|EmployeeVaccinationSubmission|VaccinationTypeId',
                FieldPrefix: 'VaccinationTypeIdCovidVaccineType',
                PropertyName: 'VaccinationTypeIdCovidVaccineType'
            },
            /** Relation: User - Employee User */
            EthosUserByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|EmployeeUserId',
                FieldPrefix: 'EmployeeEthosUser',
                PropertyName: 'EmployeeEthosUser'
            },
            /** Relation: User - Rejected By User */
            EthosUserByRejectedByUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|RejectedByUserId',
                FieldPrefix: 'RejectedByEthosUser',
                PropertyName: 'RejectedByEthosUser'
            },
            /** Relation: Covid Vaccine Type - Booster Vaccine1 Type */
            CovidVaccineTypeByBoosterVaccine1TypeId : {
                RelationName: 'CovidVaccineType|EmployeeVaccinationSubmission|BoosterVaccine1TypeId',
                FieldPrefix: 'BoosterVaccine1TypeIdCovidVaccineType',
                PropertyName: 'BoosterVaccine1TypeIdCovidVaccineType'
            },
            /** Relation: Covid Vaccination Submission Status */
            CovidVaccinationSubmissionStatus : {
                RelationName: 'CovidVaccinationSubmissionStatus|EmployeeVaccinationSubmission|CovidVaccinationSubmissionStatusId',
                FieldPrefix: 'CovidVaccinationSubmissionStatus',
                PropertyName: 'CovidVaccinationSubmissionStatus'
            },
            /** Relation: Covid Vaccination Status */
            CovidVaccinationStatus : {
                RelationName: 'CovidVaccinationStatus|EmployeeVaccinationSubmission|CovidVaccinationStatusId',
                FieldPrefix: 'CovidVaccinationStatus',
                PropertyName: 'CovidVaccinationStatus'
            },
    };
}

class EthosUser implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_User.';

    constructor() {
        this.ItemDetail.ItemId=2413;
        this.ItemDetail.ItemName='Ethos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    CustomerId : string = this.i + 'CustomerId';
    SubcontractorId : string = this.i + 'SubcontractorId';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    IsVaxxed : string = this.i + 'isVaxxed';

    Relations = {
            /** Relation: User - User Id */
            EthosUserBySupervisorUserId : {
                RelationName: 'Supervisor_User2',
                FieldPrefix: 'SupervisorEthosUser',
                PropertyName: 'SupervisorEthosUser'
            },
            /** Relation: Employee Vaccination Submission - User Id */
            EmployeeVaccinationSubmissionByRejectedByUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|RejectedByUserId',
                FieldPrefix: 'RejectedByEmployeeVaccinationSubmission',
                PropertyName: 'RejectedByEmployeeVaccinationSubmission'
            },
            /** Relation: Employee Vaccination Submission - User Id */
            EmployeeVaccinationSubmissionByVerifiedByUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|VerifiedByUserId',
                FieldPrefix: 'VerifiedByEmployeeVaccinationSubmission',
                PropertyName: 'VerifiedByEmployeeVaccinationSubmission'
            },
            /** Relation: Employee Summary - User Id */
            EmployeeSummaryByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeSummary|EmployeeUserId',
                FieldPrefix: 'EmployeeEmployeeSummary',
                PropertyName: 'EmployeeEmployeeSummary'
            },
            /** Relation: Employee Test - User Id */
            EmployeeTestByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeTest|EmployeeUserId',
                FieldPrefix: 'EmployeeEmployeeTest',
                PropertyName: 'EmployeeEmployeeTest'
            },
            /** Relation: Employee Vaccination Submission - User Id */
            EmployeeVaccinationSubmissionByEmployeeUserId : {
                RelationName: 'Ethos_User|EmployeeVaccinationSubmission|EmployeeUserId',
                FieldPrefix: 'EmployeeEmployeeVaccinationSubmission',
                PropertyName: 'EmployeeEmployeeVaccinationSubmission'
            },
    };
}

class EthosUserDiff implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserDiff.';

    constructor() {
        this.ItemDetail.ItemId=2572;
        this.ItemDetail.ItemName='Ethos_UserDiff';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EthosUserDiffId : string = this.i + 'Ethos_UserDiffId';
    EthosUserId : string = this.i + 'Ethos_UserId';
    FieldName : string = this.i + 'FieldName';
    OldValue : string = this.i + 'OldValue';
    NewValue : string = this.i + 'NewValue';
    ChangedDateTime : string = this.i + 'ChangedDateTime';

    Relations = {
    };
}

class EthosUserSkill implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_UserSkill.';

    constructor() {
        this.ItemDetail.ItemId=2410;
        this.ItemDetail.ItemName='Ethos_UserSkill';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserSkillId : string = this.i + 'UserSkillId';
    UserId : string = this.i + 'UserId';
    SkillCv : string = this.i + 'SkillCv';
    Dislay : string = this.i + 'Dislay';
    Meaning : string = this.i + 'Meaning';

    Relations = {
    };
}

class FieldEmployeesPayRate implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'FieldEmployeesPayRate.';

    constructor() {
        this.ItemDetail.ItemId=2522;
        this.ItemDetail.ItemName='FieldEmployeesPayRate';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    PayRate : string = this.i + 'PayRate';
    Company : string = this.i + 'Company';

    Relations = {
    };
}

class RoEthosUser implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roEthos_User.';

    constructor() {
        this.ItemDetail.ItemId=2419;
        this.ItemDetail.ItemName='roEthos_User';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    UserId : string = this.i + 'UserId';
    UserName : string = this.i + 'UserName';
    FirstName : string = this.i + 'FirstName';
    LastName : string = this.i + 'LastName';
    MiddleName : string = this.i + 'MiddleName';
    PreferredName : string = this.i + 'PreferredName';
    Suffix : string = this.i + 'Suffix';
    OfficePhone : string = this.i + 'OfficePhone';
    MobilePhone : string = this.i + 'MobilePhone';
    WachterJobTitleId : string = this.i + 'WachterJobTitleId';
    WachterJobTitle : string = this.i + 'WachterJobTitle';
    UserTypeCv : string = this.i + 'UserTypeCv';
    UserTypeDisplay : string = this.i + 'UserTypeDisplay';
    StaffingAgencyId : string = this.i + 'StaffingAgencyId';
    ResourceGroupCv : string = this.i + 'ResourceGroupCv';
    ResourceGroup : string = this.i + 'ResourceGroup';
    EmployeeGroupId : string = this.i + 'EmployeeGroupId';
    EmployeeGroupCode : string = this.i + 'EmployeeGroupCode';
    EmployeeGroupDescription : string = this.i + 'EmployeeGroupDescription';
    EmpHireDate : string = this.i + 'empHireDate';
    AddressLongitude : string = this.i + 'AddressLongitude';
    AddressLatitude : string = this.i + 'AddressLatitude';
    WachterTeamId : string = this.i + 'WachterTeamId';
    WachterDepartmentId : string = this.i + 'WachterDepartmentId';
    BirthMonth : string = this.i + 'BirthMonth';
    BirthDate : string = this.i + 'BirthDate';
    Email : string = this.i + 'Email';
    SupervisorUserId : string = this.i + 'SupervisorUserId';
    UserStatusWs : string = this.i + 'UserStatusWs';
    UserStatusMeaning : string = this.i + 'UserStatusMeaning';
    IsTerminated : string = this.i + 'IsTerminated';
    PictureAttachmentFileExtension : string = this.i + 'PictureAttachmentFileExtension';
    PictureAttachmentDisplay : string = this.i + 'PictureAttachmentDisplay';
    PictureAttachmentField : string = this.i + 'PictureAttachmentField';
    AdjustedStartDate : string = this.i + 'AdjustedStartDate';
    OfficeId : string = this.i + 'OfficeId';
    OfficeName : string = this.i + 'OfficeName';
    StreetAddress1 : string = this.i + 'StreetAddress1';
    StreetAddress2 : string = this.i + 'StreetAddress2';
    City : string = this.i + 'City';
    StateProvinceShortName : string = this.i + 'StateProvinceShortName';
    PostalCode : string = this.i + 'PostalCode';
    HasVehicle : string = this.i + 'HasVehicle';
    ShowUserOnMap : string = this.i + 'ShowUserOnMap';
    RowInsertDateTime : string = this.i + 'RowInsertDateTime';
    TeamName : string = this.i + 'TeamName';
    TeamShortName : string = this.i + 'TeamShortName';
    TeamNickName : string = this.i + 'TeamNickName';
    DepartmentName : string = this.i + 'DepartmentName';
    DepartmentShortName : string = this.i + 'DepartmentShortName';
    WachterDivisionId : string = this.i + 'WachterDivisionId';
    DivisionName : string = this.i + 'DivisionName';
    DivisionShortName : string = this.i + 'DivisionShortName';
    NameLastFirst : string = this.i + 'NameLastFirst';
    NameLastPrefered : string = this.i + 'NameLastPrefered';
    NameLastFirstPrefered : string = this.i + 'NameLastFirstPrefered';
    NameFirstLast : string = this.i + 'NameFirstLast';
    NamePreferedLast : string = this.i + 'NamePreferedLast';
    NameFirstPreferedLast : string = this.i + 'NameFirstPreferedLast';
    NameFirstMiddleLast : string = this.i + 'NameFirstMiddleLast';
    NamePreferedMidInitialLast : string = this.i + 'NamePreferedMidInitialLast';
    NameLastFirstPreferedStatus : string = this.i + 'NameLastFirstPreferedStatus';
    EmployeeType : string = this.i + 'EmployeeType';
    StateProvinceId : string = this.i + 'StateProvinceId';
    PictureAttachmentFileKey : string = this.i + 'PictureAttachmentFileKey';
    NameLastFirstPreferedType : string = this.i + 'NameLastFirstPreferedType';
    IsActive : string = this.i + 'IsActive';
    SpecialInstructions : string = this.i + 'SpecialInstructions';
    BirthMonthDate : string = this.i + 'BirthMonthDate';
    TerritoryId : string = this.i + 'TerritoryId';
    TerritoryName : string = this.i + 'TerritoryName';
    Company : string = this.i + 'Company';
    LicenseCount : string = this.i + 'LicenseCount';
    AXId : string = this.i + 'AXId';

    Relations = {
            /** Relation: Ro Ethos User - Supervisor User */
            RoEthosUserByUserId : {
                RelationName: 'roEthos_User|roEthos_User|SupervisorId2',
                FieldPrefix: 'UserIdRoEthosUser',
                PropertyName: 'UserIdRoEthosUser'
            },
    };
}


// Generated Entity Interfaces
export interface CovidConfigurationEntity extends DwOrmData {
    // Attributes
    CovidConfigurationId?: number;
    TestFrequencyDays?: number;
    QuarantineDays?: number;
    TestStartAfterPositiveDays?: number;
    EffectiveStartDate?: string;
    RequireWeeklyTesting?: boolean;
    EffectiveEndDate?: string;
    ShowHomePageContent?: boolean;
    HomePageMessage?: string;
    ReminderEmail1DaysBefore?: number;
    ReminderEmail2DaysBefore?: number;
    ReminderEmail3DaysBefore?: number;

    // Relations
}

export interface CovidTestResultTypeEntity extends DwOrmData {
    // Attributes
    CovidTestResultTypeId?: number;
    CovidTestResultType?: string;

    // Relations
    EmployeeTest? : EmployeeTestEntity[];
}

export interface CovidTestStatusEntity extends DwOrmData {
    // Attributes
    CovidTestStatusId?: number;
    CovidTestStatus?: string;
    CovidTestStatusActionTest?: string;
    ButtonClasses?: string;

    // Relations
    EmployeeTest? : EmployeeTestEntity[];
}

export interface CovidTestTypeEntity extends DwOrmData {
    // Attributes
    CovidTestTypeId?: number;
    CovidTestType?: string;

    // Relations
    EmployeeTest? : EmployeeTestEntity[];
}

export interface CovidVaccinationStatusEntity extends DwOrmData {
    // Attributes
    CovidVaccinationStatusId?: number;
    CovidVaccinationStatus?: string;

    // Relations
    EmployeeSummary? : EmployeeSummaryEntity[];
    EmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
    PreviousEmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
    EmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
}

export interface CovidVaccinationSubmissionStatusEntity extends DwOrmData {
    // Attributes
    CovidVaccinationSubmissionStatusId?: number;
    StatusDisplay?: string;
    StatusActionText?: string;
    ButtonClasses?: string;

    // Relations
    EmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
}

export interface CovidVaccineTypeEntity extends DwOrmData {
    // Attributes
    CovidVaccineTypeId?: number;
    CovidVaccineType?: string;
    RequiredShots?: number;

    // Relations
    BoosterVaccine1TypeIdEmployeeSummary? : EmployeeSummaryEntity[];
    VaccineTypeIdEmployeeSummary? : EmployeeSummaryEntity[];
    VaccinationTypeIdEmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
    BoosterVaccine1TypeIdEmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
}

export interface CovidWorkStatusEntity extends DwOrmData {
    // Attributes
    CovidWorkStatusId?: number;
    CovidWorkStatus?: string;

    // Relations
    EmployeeSummary? : EmployeeSummaryEntity[];
    EmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
    PreviousEmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
}

export interface EmployeeReminderNotificationEntity extends DwOrmData {
    // Attributes
    EmployeeSummaryId?: number;
    DaysUntilNextTest?: number;
    NextTestDate?: string;
    CreatedDateTime?: string;
    EmployeeReminderNotificationId?: number;

    // Relations
    EmployeeSummary? : EmployeeSummaryEntity;
}

export interface EmployeeServiceDatesEntity extends DwOrmData {
    // Attributes
    PersonnelNumber?: string;
    HireDate?: string;
    EmploymentStartDate?: string;
    AdjustedServiceDate?: string;

    // Relations
}

export interface EmployeeSummaryEntity extends DwOrmData {
    // Attributes
    EmployeeSummaryId?: number;
    EmployeeUserId?: number;
    CovidVaccinationStatusId?: number;
    CovidWorkStatusId?: number;
    RequiresWeeklyTesting?: boolean;
    NextTestDate?: string;
    QuarantineStartDate?: string;
    QuarantineEndDate?: string;
    Vaccine1Date?: string;
    Vaccine2Date?: string;
    BoosterVaccine1TypeId?: number;
    BoosterVaccine1Date?: string;
    VaccinationCardFileId?: number;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    LastEmployeeTestId?: number;
    VaccineTypeId?: number;
    LastPositiveTestId?: number;
    MedicalExemptionFileId?: number;

    // Relations
    BoosterVaccine1TypeIdCovidVaccineType? : CovidVaccineTypeEntity;
    EmployeeReminderNotification? : EmployeeReminderNotificationEntity[];
    CovidWorkStatus? : CovidWorkStatusEntity;
    VaccineTypeIdCovidVaccineType? : CovidVaccineTypeEntity;
    EmployeeEthosUser? : EthosUserEntity;
    EmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
    CovidVaccinationStatus? : CovidVaccinationStatusEntity;
    LastPositiveTestIdEmployeeTest? : EmployeeTestEntity;
    LastEmployeeTest? : EmployeeTestEntity;
}

export interface EmployeeSummaryChangeTypeEntity extends DwOrmData {
    // Attributes
    EmplyoeeSummaryChangeTypeId?: number;
    ChangeTypeDisplay?: string;
    EmailEmployee?: boolean;
    EmailSupervisor?: boolean;

    // Relations
    EmployeeSummaryChangeTypeIdEmployeeSummaryHistory? : EmployeeSummaryHistoryEntity[];
}

export interface EmployeeSummaryHistoryEntity extends DwOrmData {
    // Attributes
    EmployeeSummaryHistoryId?: number;
    EmployeeSummaryId?: number;
    EmployeeSummaryChangeTypeId?: number;
    CovidVaccinationStatusId?: number;
    PreviousCovidVaccinationStatusId?: number;
    CovidWorkStatusId?: number;
    PreviousCovidWorkStatusId?: number;
    QuarantineStartDate?: string;
    QuarantineEndDate?: string;
    DetailNotificationsComplete?: boolean;
    SummaryNotificationsComplete?: boolean;
    RequireWeeklyTesting?: boolean;
    PreviousRequireWeeklyTesting?: boolean;
    CreatedByDateTime?: string;

    // Relations
    PreviousCovidVaccinationStatus? : CovidVaccinationStatusEntity;
    PreviousCovidWorkStatus? : CovidWorkStatusEntity;
    EmployeeSummaryChangeTypeIdEmployeeSummaryChangeType? : EmployeeSummaryChangeTypeEntity;
    EmployeeSummary? : EmployeeSummaryEntity;
    CovidVaccinationStatus? : CovidVaccinationStatusEntity;
    CovidWorkStatus? : CovidWorkStatusEntity;
}

export interface EmployeeTestEntity extends DwOrmData {
    // Attributes
    EmployeeTestId?: number;
    EmployeeUserId?: number;
    TestLocation?: string;
    CovidTestTypeId?: number;
    CovidTestResultTypeId?: number;
    CovidTestStatusId?: number;
    VerifiedByUserId?: number;
    VerifiedDateTime?: string;
    RejectedByUserId?: number;
    RejectedDateTime?: string;
    RejectedNotes?: string;
    TestFileId?: number;
    TestDateTime?: string;
    CreatedBy?: number;
    CreatedDateTime?: string;
    ModifiedBy?: number;
    ModifiedDateTime?: string;
    IsProcessed?: boolean;
    ProcessedDateTime?: string;

    // Relations
    CovidTestType? : CovidTestTypeEntity;
    LastPositiveTestIdEmployeeSummary? : EmployeeSummaryEntity[];
    CovidTestStatus? : CovidTestStatusEntity;
    LastEmployeeSummary? : EmployeeSummaryEntity[];
    EmployeeEthosUser? : EthosUserEntity;
    CovidTestResultType? : CovidTestResultTypeEntity;
}

export interface EmployeeVaccinationSubmissionEntity extends DwOrmData {
    // Attributes
    EmployeeVaccinationSubmissionId?: number;
    EmployeeUserId?: number;
    SubmittedDateTime?: string;
    CovidVaccinationStatusId?: number;
    VaccinationTypeId?: number;
    Vaccine1Date?: string;
    Vaccine2Date?: string;
    BoosterVaccine1TypeId?: number;
    BoosterVaccineDate?: string;
    VaccinationCardFileId?: number;
    CovidVaccinationSubmissionStatusId?: number;
    VerifiedDateTime?: string;
    RejectedByUserId?: number;
    RejectedDateTime?: string;
    RejectedNotes?: string;
    VerifiedByUserId?: number;

    // Relations
    VerifiedByEthosUser? : EthosUserEntity;
    VaccinationTypeIdCovidVaccineType? : CovidVaccineTypeEntity;
    EmployeeEthosUser? : EthosUserEntity;
    RejectedByEthosUser? : EthosUserEntity;
    BoosterVaccine1TypeIdCovidVaccineType? : CovidVaccineTypeEntity;
    CovidVaccinationSubmissionStatus? : CovidVaccinationSubmissionStatusEntity;
    CovidVaccinationStatus? : CovidVaccinationStatusEntity;
}

export interface EthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    EmpHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    CustomerId?: number;
    SubcontractorId?: number;
    SpecialInstructions?: string;
    IsVaxxed?: boolean;

    // Relations
    SupervisorEthosUser? : EthosUserEntity[];
    RejectedByEmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
    // Duplicate property excluded
    // SupervisorEthosUser : EthosUserEntity;
    VerifiedByEmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
    EmployeeEmployeeSummary? : EmployeeSummaryEntity[];
    EmployeeEmployeeTest? : EmployeeTestEntity[];
    EmployeeEmployeeVaccinationSubmission? : EmployeeVaccinationSubmissionEntity[];
}

export interface EthosUserDiffEntity extends DwOrmData {
    // Attributes
    EthosUserDiffId?: number;
    EthosUserId?: number;
    FieldName?: string;
    OldValue?: string;
    NewValue?: string;
    ChangedDateTime?: string;

    // Relations
}

export interface EthosUserSkillEntity extends DwOrmData {
    // Attributes
    UserSkillId?: number;
    UserId?: number;
    SkillCv?: number;
    Dislay?: string;
    Meaning?: string;

    // Relations
}

export interface FieldEmployeesPayRateEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    PayRate?: string;
    Company?: string;

    // Relations
}

export interface RoEthosUserEntity extends DwOrmData {
    // Attributes
    UserId?: number;
    UserName?: string;
    FirstName?: string;
    LastName?: string;
    MiddleName?: string;
    PreferredName?: string;
    Suffix?: string;
    OfficePhone?: string;
    MobilePhone?: string;
    WachterJobTitleId?: number;
    WachterJobTitle?: string;
    UserTypeCv?: number;
    UserTypeDisplay?: string;
    StaffingAgencyId?: number;
    ResourceGroupCv?: number;
    ResourceGroup?: string;
    EmployeeGroupId?: number;
    EmployeeGroupCode?: string;
    EmployeeGroupDescription?: string;
    EmpHireDate?: string;
    AddressLongitude?: number;
    AddressLatitude?: number;
    WachterTeamId?: number;
    WachterDepartmentId?: number;
    BirthMonth?: number;
    BirthDate?: number;
    Email?: string;
    SupervisorUserId?: number;
    UserStatusWs?: number;
    UserStatusMeaning?: string;
    IsTerminated?: boolean;
    PictureAttachmentFileExtension?: string;
    PictureAttachmentDisplay?: string;
    PictureAttachmentField?: number;
    AdjustedStartDate?: string;
    OfficeId?: number;
    OfficeName?: string;
    StreetAddress1?: string;
    StreetAddress2?: string;
    City?: string;
    StateProvinceShortName?: string;
    PostalCode?: string;
    HasVehicle?: boolean;
    ShowUserOnMap?: boolean;
    RowInsertDateTime?: string;
    TeamName?: string;
    TeamShortName?: string;
    TeamNickName?: string;
    DepartmentName?: string;
    DepartmentShortName?: string;
    WachterDivisionId?: number;
    DivisionName?: string;
    DivisionShortName?: string;
    NameLastFirst?: string;
    NameLastPrefered?: string;
    NameLastFirstPrefered?: string;
    NameFirstLast?: string;
    NamePreferedLast?: string;
    NameFirstPreferedLast?: string;
    NameFirstMiddleLast?: string;
    NamePreferedMidInitialLast?: string;
    NameLastFirstPreferedStatus?: string;
    EmployeeType?: string;
    StateProvinceId?: number;
    PictureAttachmentFileKey?: string;
    NameLastFirstPreferedType?: string;
    IsActive?: number;
    SpecialInstructions?: string;
    BirthMonthDate?: string;
    TerritoryId?: number;
    TerritoryName?: string;
    Company?: string;
    LicenseCount?: number;
    AXId?: string;

    // Relations
    UserIdRoEthosUser? : RoEthosUserEntity[];
    // Duplicate property excluded
    // UserIdRoEthosUser : RoEthosUserEntity;
}



